// extracted by mini-css-extract-plugin
export default {"card":"PromoCardItem_card__7IBVE","container":"PromoCardItem_container__FCmZQ","title":"PromoCardItem_title__S2ANy","button":"PromoCardItem_button__w7trI"};